import { ProjectLinkWithIcon } from './ProjectLinkWithIcon';
import styles from './RadioLabel.module.scss';

type Props = {
  label: string;
  helperText?: string;
  primaryUrl?: string;
  secondaryUrl?: string;
};

export const RadioLabel = ({
  label,
  helperText,
  primaryUrl,
  secondaryUrl,
}: Props) => (
  <span className={styles.labelContainer}>
    <span className={styles.labelText}>{label}</span>

    {!!helperText && (
      <span className={styles.fieldText}>
        {primaryUrl && secondaryUrl ? (
          <span>
            Includes PWC US’s{' '}
            <ProjectLinkWithIcon href={primaryUrl}>
              data use consent provision
            </ProjectLinkWithIcon>{' '}
            which governs{' '}
            <ProjectLinkWithIcon href={secondaryUrl}>
              secondary use of client data
            </ProjectLinkWithIcon>{' '}
            {helperText}
          </span>
        ) : (
          helperText
        )}
      </span>
    )}
  </span>
);
